import { render, staticRenderFns } from "./PortfolioForm.vue?vue&type=template&id=91185856&scoped=true&"
import script from "./PortfolioForm.vue?vue&type=script&lang=js&"
export * from "./PortfolioForm.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioForm.vue?vue&type=style&index=0&id=91185856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91185856",
  null
  
)

export default component.exports